import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { openModal } from '../actions/open-modal';
import { MODAL_TYPE_DEMO_MODE } from '../constants/modal-types';
import createHocName from '../services/create-hoc-name';
import withAuth from './with-auth';

const NAME = 'PreventClickInDemoMode';

export default function preventClickInDemoMode(WrappedComponent) {
  class PreventClickInDemoMode extends Component {
    static displayName = createHocName(NAME, WrappedComponent);

    handleClick = event => {
      const { isDemoMode, viewMode, onClick, openModal } = this.props;

      if (isDemoMode) {
        openModal(MODAL_TYPE_DEMO_MODE, { viewMode });
      } else {
        onClick && onClick(event);
      }
    };

    render() {
      return <WrappedComponent {...this.props} onClick={this.handleClick}/>;
    }
  }

  PreventClickInDemoMode.propTypes = {
    isDemoMode: PropTypes.bool.isRequired,
    viewMode: PropTypes.string.isRequired,
    openModal: PropTypes.func.isRequired,
    onClick: PropTypes.func,
  };

  hoistNonReactStatics(PreventClickInDemoMode, WrappedComponent);

  const mapStateToProps = state => ({
    viewMode: state.viewMode,
    isDemoMode: state.isDemoMode,
  });

  const mapDispatchToProps = {
    openModal,
  };

  return connect(mapStateToProps, mapDispatchToProps)(withAuth(PreventClickInDemoMode));
}



// WEBPACK FOOTER //
// ./app/hoc/prevent-click-in-demo-mode.js